export const UPLOAD_AUDIT_QUERY_KEY = 'upload-audit';
